import {FITH2Scatter} from "../symbols/FITH2Scatter";
import {gsap} from "gsap";
import {FITH2SoundManager} from "../sound/FITH2SoundManager";
import {FireInTheHole2} from "../FireInTheHole2";
import {FITH2SymbolStates} from "../symbols/FITH2Symbol";
import {GameMode} from "@nolimit/slot-game/bin/flowcontrol/GameMode";

export class ScatterCounter {
    private static scatters:FITH2Scatter[] = [];

    constructor() {
        ScatterCounter.scatters = [];
    }

    public static reset() {
        ScatterCounter.scatters.forEach((scatter:FITH2Scatter) => {
            scatter.stopAnimation(FireInTheHole2.model.freespinTriggeredThisSpin);
        });
        ScatterCounter.scatters = [];
    }

    public static onRestore():void {
        if(!FireInTheHole2.model.isRestore) {
            return;
        }

        const nrScatters:number = ScatterCounter.scatters.length;
        ScatterCounter.scatters.forEach((scatter:FITH2Scatter, i:number) => {
            if(nrScatters === 2) {
                scatter.setRestoreState2(i);
            } else {
                scatter.setRestoreState();
            }
        });
    }

    public static addScatter(value:FITH2Scatter):gsap.core.Timeline {
        ScatterCounter.scatters.push(value);
        const tl = gsap.timeline();
        if(ScatterCounter.scatters.length === 1) {
            tl.add([
                () => FITH2SoundManager.playSound("scatter1"),
                value.getStateAnimation(FITH2SymbolStates.LANDING)
            ]);
        } else if(ScatterCounter.scatters.length === 2) {
            tl.add(() => FITH2SoundManager.playSound("scatter2"));
            ScatterCounter.scatters.forEach((scatter:FITH2Scatter) => {
                if(!(value.reelId === 5 && !FireInTheHole2.model.isNextRespin)) {
                    tl.add(scatter.playScatterAttention(), 0);
                }
            });
        } else if(ScatterCounter.scatters.length === 3) {
            tl.add(ScatterCounter.scatters[2].playThirdScatterLanding(), 0);
            ScatterCounter.scatters.forEach((scatter:FITH2Scatter) => {
                tl.add(scatter.playThirdScatter());
            });
        } else if(ScatterCounter.scatters.length >= 4) {
            tl.add(value.playForthScatter());
            ScatterCounter.scatters.forEach((scatter:FITH2Scatter) => {
                tl.add(scatter.playThirdScatter());
            });
        }

        return tl;
    }

    public static get allScatters():FITH2Scatter[] {
        return ScatterCounter.scatters;
    }
}